import Select from '../../../../components/Select'
import DatePicker from '../../../../components/DatePicker'
import {
  formatUsd,
  formatPlanDate,
  firstPaymentMinIsoDate,
  firstPaymentMaxIsoDate
} from '../installmentFormat'

export default function ScheduleStep ({ invoice, frequency, installmentCount, startDate, schedule, onChange }) {
  const counts = [2, 3, 4, 5, 6].map((n) => ({ value: String(n), label: `${n} payments` }))
  const minDate = firstPaymentMinIsoDate()
  const maxDate = firstPaymentMaxIsoDate()

  return (
    <div className='flex flex-col gap-4'>
      <p className='text-sm text-slate-600 dark:text-slate-300'>
        Split {formatUsd(invoice?.invoiceAmount)} into weekly or monthly payments. You can choose up to six payments.
      </p>
      <div className='grid grid-cols-1 sm:grid-cols-3 gap-3'>
        <div className='flex flex-col gap-1'>
          <span className='text-xs font-semibold text-slate-500'>Frequency</span>
          <Select
            value={frequency}
            onChange={(val) => onChange({ frequency: val })}
            options={[{ value: 'weekly', label: 'Weekly' }, { value: 'monthly', label: 'Monthly' }]}
          />
        </div>
        <div className='flex flex-col gap-1'>
          <span className='text-xs font-semibold text-slate-500'>Number of payments</span>
          <Select
            value={String(installmentCount)}
            onChange={(val) => onChange({ installmentCount: Number(val) })}
            options={counts}
          />
        </div>
        <div className='flex flex-col gap-1'>
          <span className='text-xs font-semibold text-slate-500'>First payment date</span>
          <DatePicker
            value={startDate}
            minDate={minDate}
            maxDate={maxDate}
            onChange={(val) => onChange({ startDate: val })}
          />
          <span className='text-xs text-slate-500 dark:text-slate-400'>Tomorrow through two weeks from today.</span>
        </div>
      </div>
      <div className='rounded-2xl border border-gray-200 dark:border-slate-700 overflow-hidden'>
        {(schedule || []).map((row) => (
          <div key={row.sequence} className='flex justify-between px-4 py-3 border-b last:border-b-0 border-gray-100 dark:border-slate-700'>
            <span className='text-sm text-slate-600 dark:text-slate-300'>Payment {row.sequence} · {formatPlanDate(row.scheduledDate)}</span>
            <span className='text-sm font-semibold text-slate-900 dark:text-white'>{formatUsd(row.amount)}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
